import FormattedMessage from 'I18n/components/FormattedMessage';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import usageTracker from '../../utils/usageTracker';
import { getSignupCtaHref } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SignupSectionMinimalDark = ({
  hubsSignupCta
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const handleSignupClick = () => {
    usageTracker.track('interaction', {
      action: 'signup-button-click',
      value: hubsSignupCta
    });
  };
  return /*#__PURE__*/_jsx(View, {
    as: "section",
    backgroundColor: "fill-accent-neutral-subtle",
    padding: "500",
    children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        columnGap: "1000",
        flexWrap: "wrap",
        justifyContent: "center",
        rowGap: "400",
        children: [/*#__PURE__*/_jsx(Text, {
          color: "text-inverse-default",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.signupSectionMinimal.description"
          })
        }), /*#__PURE__*/_jsx(Button, {
          href: getSignupCtaHref(hubsSignupCta),
          onClick: () => handleSignupClick(),
          size: isMobile ? 'small' : 'medium',
          use: "primary-white",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.signupSectionMinimal.ctaText"
          })
        })]
      })
    })
  });
};
export default SignupSectionMinimalDark;